/**
 * Loại chương trình mục tiêu
 */
export default {
  /**
   * CTMT
   */
  Target: 1,

  /**
   * Dự án
   */
  Project: 2,
  Construction: 3, // Công trình
  WorkItem: 4, // Hạng mục công trình
};
